import styled from 'styled-components'

export const ErrorText = styled.p`
    color: var(--primary-main);
    font-weight: bold;
    animation: slide-up 0.7s ease-in-out;
    @keyframes slide-up {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
`